<template>
  <div class="content_menu clearfix">
    <div class="left" style="width:343px">
      <div class="left" style="width:178px;">
        <TheFoodMenu active="seafood" />
      </div>

      <div class="left" style="margin:0px 0 0 29px;">
        <img src="/assets/images/titles/menu_left_seafood.png" />
      </div>

      <br clear="all" />
    </div>

    <div class="right" style="width:552px; margin:8px 0px 0 0;">
      <div class="left" style="width:522px; height:117px;">
        <img src="/assets/images/menu_img/seafood.png" />
      </div>

      <br clear="all" />

      <div class="product-container">
        <ProductList :products="products" />

        <br clear="all" />

        <div class="left" style="margin:10px 0 0 -20px;">
          <img src="/assets/images/menu_img/menu_salad_bottom.png" />
        </div>

        <br clear="all" />

        <div class="left" style="margin:18px 0 0 -240px;">
          <img src="/assets/images/menu_img/menu_img7.png" />
        </div>
      </div>

      <div class="menu_right">
        <div class="right" style="margin:-116px 14px 0 0;">
          <img src="/assets/images/menu_img/menu_right_seafood.png" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import TheFoodMenu from '@/components/TheFoodMenu.vue';
import ProductList from '@/components/ProductList.vue';

export default {
  name: 'Seafood',

  components: {
    TheFoodMenu,
    ProductList,
  },

  data() {
    return {
      products: [
        {
          id: 1,
          name: 'FISH & CHIPS',
          description: 'Wild Alaskan Pollock fillets, lightly battered and fried to perfection. Served with fries and tartar sauce',
          modifiers: [],
        },
        {
          id: 2,
          name: 'SHRIMP & CHIPS',
          description: '6 shrimp lightly battered and fried to perfection. Served with fries and homemade cocktail sauce',
          modifiers: [],
        },
      ],
    };
  },
};
</script>
